const BookingRequestSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-4">
      {Array(3)
        .fill(0)
        .map((_, index) => (
          <div
            key={index}
            className="bg-white p-5 rounded-md shadow-md border border-gray-300 flex flex-col gap-3 text-gray-700 animate-pulse"
          >
            <div className="h-6 w-32 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-24 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-20 bg-gray-300 rounded-md"></div>
            <div className="h-4 w-28 bg-gray-300 rounded-md"></div>
            <div className="h-3 w-full bg-gray-300 rounded-md"></div>
            <div className="h-10 bg-gray-300 rounded-md"></div>
          </div>
        ))}
    </div>
  );
};

export default BookingRequestSkeleton;
